import type { CheckboxCustomEvent } from '@ionic/react'
import { ParseKeys } from 'i18next'
import { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { IonCheckbox } from './styled'

type LabelOnly = {
  label: string
  labelI18n?: never
}

type LabelI18nOnly = {
  label?: never
  labelI18n: ParseKeys
}

type RequiredLabel = LabelOnly | LabelI18nOnly

type CheckboxProps = {
  name: string
} & RequiredLabel &
  ComponentProps<typeof IonCheckbox>

export function Checkbox({
  label,
  labelI18n,
  name,
  ...checkboxProps
}: CheckboxProps) {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      defaultValue={false}
      render={({ field: { onChange, value } }) => {
        return (
          <IonCheckbox
            checked={value}
            onIonChange={(e: CheckboxCustomEvent) => {
              onChange(e.detail.checked)
            }}
            {...checkboxProps}
            labelPlacement='end'
            justify='start'
            mode='md'
          >
            {label ?? (t(labelI18n) as string)}
          </IonCheckbox>
        )
      }}
    />
  )
}
